import { tagIcon } from "@speisekarte/core";

/** A tag's symbol (S21) as SVG, in the colour of the text around it. */
export function TagSymbol({ id, size = 20, label }: { id: string; size?: number; label?: string }) {
  const icon = tagIcon(id);
  if (!icon) return null;
  return (
    <svg className="tag-symbol" viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      {icon.d.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}
